/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pedometer': {
    width: 16,
    height: 16,
    viewBox: '0 0 67.56 74.63',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M25 49.3h-1.34a40.77 40.77 0 0 0-7.65.66 41.31 41.31 0 0 0-7.4 2l-1.25.48-.8-1.07A32.19 32.19 0 0 1 1.1 38C-1 26.44 2.49 16.44 9.14 14.74l.56-.12c6.94-1.24 14 7.09 16.15 19A32.17 32.17 0 0 1 25.36 48zM28.32 67.41c-.81 3.3-2.62 5.72-5.24 6.48l-.19.05c-5 1.27-10.71-4.07-13.06-12.16-.22-.77-.41-1.55-.56-2.32L9 57.88l17.47-5.07.59 1.5c.29.74.55 1.5.77 2.25a25.7 25.7 0 0 1 .76 3.5M63.17 35.47q-.44.8-.92 1.54l-.73 1.12-1.28-.4a41.31 41.31 0 0 0-7.52-1.54 40.77 40.77 0 0 0-7.66-.19l-1.33.1-.46-1.26a32.17 32.17 0 0 1-1.43-14.35c1.34-12 7.88-20.77 14.88-20l.56.08c6.74 1.26 10.85 11 9.54 22.69a37.52 37.52 0 0 1-.62 3.81M47.23 60.57c-5.12-1.13-7.69-8.59-5.84-17 .17-.76.38-1.54.62-2.3l.49-1.54 17.77 3.91-.2 1.6c-.1.78-.23 1.57-.4 2.35-1.81 8.23-7.19 13.93-12.24 13z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/pedometer.js